/* Enhance native category disclosures; collection links work without JS. */
(() => {
  const initialize = () => {
    document.querySelectorAll('.gg-category-menu').forEach(menu => {
      if (menu.dataset.ggReady) return;
      menu.dataset.ggReady = 'true';
      const summary = menu.querySelector('summary');
      const navigation = menu.closest('nav');
      const desktop = !menu.classList.contains('gg-category-menu--mobile');
      let openedByHover = false;
      const closeSiblings = () => navigation.querySelectorAll('.gg-category-menu').forEach(other => {
        if (other !== menu) other.open = false;
      });
      menu.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(menu.open));
        if (menu.open) closeSiblings();
      });
      summary.setAttribute('aria-expanded', String(menu.open));
      summary.addEventListener('click', event => {
        if (openedByHover && event.detail > 0) {
          event.preventDefault();
          openedByHover = false;
          return;
        }
        if (!menu.open) closeSiblings();
      });
      if (desktop) {
        menu.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          closeSiblings();
          menu.open = true;
          openedByHover = true;
        });
        menu.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse' && !menu.contains(document.activeElement)) {
            menu.open = false;
            openedByHover = false;
          }
        });
        menu.addEventListener('focusout', event => {
          if (!menu.contains(event.relatedTarget) && !menu.matches(':hover')) menu.open = false;
        });
      }
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        event.stopPropagation();
        menu.open = false;
        summary.focus();
      });
      document.addEventListener('click', event => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
